import styled from 'styled-components';

export const FieldErrorMessageContainer = styled.div`
  display: flex;
  padding: 4px 0px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 4px;
  background: var(--accent-color-gray);
  width: 100%;
`;

export const FieldErrorMessageText = styled.div`
  color: var(--error-900);
  font-feature-settings: 'clig' off, 'liga' off;
  /* 14px/regular */
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 114.286% */
`;
